import { render, staticRenderFns } from "./ProfileAdvice.vue?vue&type=template&id=25f1cae7&"
import script from "./ProfileAdvice.vue?vue&type=script&lang=ts&"
export * from "./ProfileAdvice.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileAdvice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports